import type { Site } from '@/types';

/** A site's public JBS console, served through the WireGuard proxy at *.jeket.direct. */
export function siteWebHost(site: Pick<Site, 'slug'>): string {
  return `${site.slug}.jeket.direct`;
}

/**
 * A site that runs JBS with a console to open: JBS installed and a slug for
 * its jeket.direct host. Production lists these and Home counts them.
 */
export function hasJbsConsole(site: Pick<Site, 'jbsStatus' | 'slug'>): boolean {
  return site.jbsStatus === 'installed' && !!site.slug;
}

export function siteWebUrl(site: Pick<Site, 'slug'>): string {
  return `https://${siteWebHost(site)}`;
}

// Deep links into the JBS console. Its router (JBS jeket-orchestrator
// frontend App.tsx) serves a Live Event at `/events/:id` and one of its
// AirChains at `/events/:id/airchains/:name`, both keyed by the Kubernetes
// metadata.name (LiveEvents.tsx and event/AirChainsPage.tsx navigate with
// those). An AirChain bound to no Live Event has no page there.

/** A production (JBS LiveEvent) in the site's console. */
export function siteProductionUrl(site: Pick<Site, 'slug'>, liveEventName: string): string {
  return `${siteWebUrl(site)}/events/${encodeURIComponent(liveEventName)}`;
}

/** One AirChain of a production in the site's console. */
export function siteAirChainUrl(site: Pick<Site, 'slug'>, liveEventName: string, airChainName: string): string {
  return `${siteProductionUrl(site, liveEventName)}/airchains/${encodeURIComponent(airChainName)}`;
}
